var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "edit-area" } },
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.modal.title, "footer-hide": "" },
          model: {
            value: _vm.modal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.modal, "visible", $$v)
            },
            expression: "modal.visible",
          },
        },
        [
          _c(
            "Form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "editAreaForm",
              attrs: { model: _vm.editArea, rules: _vm.editAreaRule },
            },
            [
              _c(
                "FormItem",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userType <= 3,
                      expression: "userType <= 3",
                    },
                  ],
                  attrs: { label: "省份", prop: "provinceCode" },
                },
                [
                  _c(
                    "Select",
                    {
                      staticStyle: { width: "420px" },
                      on: { "on-change": _vm.changeProvince },
                      model: {
                        value: _vm.editArea.provinceCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.editArea, "provinceCode", $$v)
                        },
                        expression: "editArea.provinceCode",
                      },
                    },
                    _vm._l(_vm.areaController.provinceList, function (item) {
                      return _c(
                        "Option",
                        { key: item.code, attrs: { value: item.code } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.userType <= 4
                ? _c(
                    "FormItem",
                    { attrs: { label: "城市", prop: "cityCode" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "420px" },
                          on: { "on-change": _vm.changeCity },
                          model: {
                            value: _vm.editArea.cityCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.editArea, "cityCode", $$v)
                            },
                            expression: "editArea.cityCode",
                          },
                        },
                        _vm._l(_vm.areaController.cityList, function (item) {
                          return _c(
                            "Option",
                            { key: item.code, attrs: { value: item.code } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.userType <= 5
                ? _c(
                    "FormItem",
                    { attrs: { label: "区域", prop: "areaCode" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "420px" },
                          on: { "on-change": _vm.changeArea },
                          model: {
                            value: _vm.editArea.areaCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.editArea, "areaCode", $$v)
                            },
                            expression: "editArea.areaCode",
                          },
                        },
                        _vm._l(_vm.areaController.areaList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.code,
                              attrs: { value: item.code },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.changeAreaName(item.name)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.userType > 3 && _vm.userType <= 5
                ? _c(
                    "FormItem",
                    { attrs: { label: "街道", prop: "streetCode" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "420px" },
                          on: { "on-change": _vm.changeStreet },
                          model: {
                            value: _vm.editArea.streetCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.editArea, "streetCode", $$v)
                            },
                            expression: "editArea.streetCode",
                          },
                        },
                        _vm._l(_vm.areaController.streetList, function (item) {
                          return _c(
                            "Option",
                            { key: item.code, attrs: { value: item.code } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "FormItem",
                { attrs: { label: "机构", prop: "institutionId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "420px" },
                      attrs: {
                        placeholder: "请选择机构",
                        clearable: "",
                        filterable: "",
                        size: "small",
                        transfer: "true",
                        "popper-append-to-body": false,
                      },
                      model: {
                        value: _vm.editArea.institutionId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.editArea,
                            "institutionId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "editArea.institutionId",
                      },
                    },
                    _vm._l(_vm.areaController.institutionList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        staticStyle: { width: "420px", "z-index": "9999" },
                        attrs: {
                          label:
                            item.name +
                            (item.subordinate && item.subordinate.length > 0
                              ? "-" + item.subordinate
                              : ""),
                          value: item.id,
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleRemoteMethodChange(item)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "FormItem",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("确定")]
                  ),
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      on: {
                        click: function ($event) {
                          _vm.modal.visible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }